export default "__VITE_ASSET__DvJHJ4Ia__"